export const voyageLogColumns: any[] = [
  {
    field: 'startLocationAreaName',
    title: 'Start Location Area',
    filter: 'text',
    width: 150,
    minWidth: 150
  },
  {
    field: 'startLocationName',
    title: 'Start Location',
    filter: 'text',
    width: 170,
    minWidth: 170
  },
  {
    field: 'startDateShow',
    title: 'Start Date',
    filter: 'text',
    width: 170,
    minWidth: 170
  },
  {
    field: 'endLocationAreaName',
    title: 'End Location Area',
    filter: 'text',
    width: 150,
    minWidth: 150
  },
  {
    field: 'endLocationName',
    title: 'End Location',
    filter: 'text',
    width: 170,
    minWidth: 170
  },
  {
    field: 'endDateShow',
    title: 'End Date',
    filter: 'text',
    width: 170,
    minWidth: 170
  },
  {
    field: 'voyageDurationShow',
    title: 'Voyage Duration',
    filter: 'text',
    width: 170,
    minWidth: 170
  },
  {
    field: 'voyageNumber',
    title: 'Voyage Number',
    filter: 'numeric',
    width: 120,
    minWidth: 120
  },
  {
    field: 'distance',
    title: 'Distance (nm)',
    filter: 'numeric',
    width: 110,
    minWidth: 110
  },
  {
    field: 'startCargoLoad',
    title: 'Start Cargo Load (t)',
    filter: 'numeric',
    width: 140,
    minWidth: 140
  },
  {
    field: 'endCargoLoad',
    title: 'End Cargo Load (t)',
    filter: 'numeric',
    width: 140,
    minWidth: 140
  },
  {
    field: 'adjustment',
    title: 'Adjustment (t)',
    filter: 'numeric',
    allowNegative: false,
    width: 180
  },
  {
    field: 'completed',
    title: 'Status',
    filter: 'boolean',
    width: 180
  },
  {
    field: 'actions',
    title: '',
    filterable: false,
    width: 120
  },
];




// WEBPACK FOOTER //
// ./src/pages/voyage-log/voyage-log-component/voyage-log-grid.config.ts